import apiClient from "./apiClient";
import {
  getEmail,
  getOrgCode,
  getOrgName,
  getUserName,
} from "../components/shared/util";
const PEOPLE_PATH = "/api/v3/reports";

// GENERATE COMPARISION ANALYSIS API
export const getGenerateComparisonAnalysis = async (data) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/generateComparisonAnalysis`,
    data
  );
  return response.data;
};
